import { ContextType } from 'react';
import { CLUSTER_CONSTANTS, CLUSTER_TYPE, PluginName } from '../constants/clusterConstants';
import { I18nContext } from '../contexts/I18nProvider';
import { Cluster, ClusterId } from '../slices/clusters';

export const determineAddClusterButtonWording = (
  parentsClusters: Cluster[],
  t: ContextType<typeof I18nContext>['t'],
) => {
  let buttonTitle = t('Clusters.add_cluster');
  if (parentsClusters?.length) {
    let cumaNumber = 0;
    let etaNumber = 0;

    parentsClusters.forEach((parentCluster) => {
      switch (parentCluster.cluster_type) {
        case 'CUMA':
          cumaNumber++;
          break;
        case 'ETA':
          etaNumber++;
          break;
        default:
          break;
      }
    });

    if (cumaNumber && !etaNumber) {
      buttonTitle = t('Clusters.add_cluster_for_cuma');
    } else if (etaNumber && !cumaNumber) {
      buttonTitle = t('Clusters.add_cluster_for_eta');
    }
  }
  return buttonTitle;
};

export function isPluginActivated(cluster: Cluster | undefined, pluginName: PluginName) {
  if (!cluster) return false;
  const plugins = cluster.plugins || [];
  return plugins.findIndex((p) => p.option === pluginName && p.activated) !== -1;
}

/**
 * Get information on a the parents of a cluster: whether the cluster has parents and is a farm, and whether the cluster
 * is a child of a CUMA or an ETA
 */
export function getChildClusterType(cluster: Cluster | undefined, clustersById: Record<ClusterId, Cluster>) {
  const parentClusters = cluster?.parent_cluster_ids || [];
  const isFarmAndChild = cluster?.cluster_type === CLUSTER_TYPE.FARM && parentClusters.length > 0;
  const isChildOfCuma =
    isFarmAndChild && !!parentClusters.find((id) => clustersById[id]?.cluster_type === CLUSTER_TYPE.CUMA);
  const isChildOfEta =
    isFarmAndChild && !!parentClusters.find((id) => clustersById[id]?.cluster_type === CLUSTER_TYPE.ETA);

  return { isFarmAndChild, isChildOfCuma, isChildOfEta };
}

export function hasAtLeastPremiumPlan(c?: Cluster) {
  return c?.plan === CLUSTER_CONSTANTS.PLANS.PREMIUM || c?.plan === CLUSTER_CONSTANTS.PLANS.PREMIUM_PLUS;
}
